(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('selectorV2', ["path", "$timeout", function (path, $timeout) {
        return {
            restrict: 'A',
            replace: true,
            templateUrl: path('gui-v2').directive('selector-v2').template(),
            scope: {
                model: '=selectorV2',
                variants: '=',
                change: '&?',
                noVariantsCaption: '@?',
                isOpen: '=?dropdownOpen',
                hideSelected: '@?',
                options: '=?',
                disabled: '=?'
            },
            link: function ($scope, element, attrs) {
                $scope.change = $scope.change || _.noop;
                $scope.options = $scope.options || {};
                $scope.multiple = $scope.options.multiple;
                $scope.disabled = $scope.disabled || false;
                $scope.getToggleIcon = function () {
                    var fa_className;
                    if ($scope.options.dropUpper) {
                        fa_className = { 'fa fa-chevron-up': true };
                    } else {
                        fa_className = { 'fa fa-chevron-down': true };
                    }
                    return fa_className;
                };
                $scope.setVariant = function ($event, variant) {
                    $event.preventDefault();
                    if (variant && variant.disabled) {
                        $event.stopPropagation();
                        return;
                    }
                    var value = _(variant).isObject() ? variant.id : variant;
                    var prev = $scope.model;
                    var emitChange = false;
                    if (!$scope.multiple) {
                        $scope.model = value;
                        if (prev != $scope.model) {
                            emitChange = true;
                        }
                    } else {
                        $event.stopPropagation();
                        if (!$scope.model || !$scope.model.push) {
                            $scope.model = [];
                        }
                        var idx = $scope.model.indexOf(value);
                        if (idx === -1) {
                            $scope.model.push(value);
                        } else {
                            $scope.model.splice(idx, 1);
                        }
                        emitChange = true;
                    }
                    if (!$scope.options.emitChangeOnClose && emitChange) {
                        $timeout(function () {
                            $scope.change({
                                newValue: $scope.model,
                                oldValue: prev
                            });
                        });
                    }
                    $scope.modelTruncationTip = null;
                };
                $scope.checkAll = function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    var prev = $scope.model;
                    var emitChange = false;
                    if ($scope.isAllChecked()) {
                        $scope.model = [];
                        if (prev && prev.length) {
                            emitChange = true;
                        }
                    } else {
                        $scope.model = _($scope.variants).map(function (v) {
                            var val = _(v).isObject() ? v.id : v;
                            emitChange = emitChange || !_(prev).includes(val);
                            return val;
                        });
                    }
                    if (!$scope.options.emitChangeOnClose && emitChange) {
                        $timeout(function () {
                            $scope.change({
                                newValue: $scope.model,
                                oldValue: prev
                            });
                        });
                    }
                };
                $scope.isAllChecked = function () {
                    return !_($scope.variants).find(function (v) {
                        var val = _(v).isObject() ? v.id : v;
                        return !_($scope.model).includes(val);
                    });
                };
                $scope.emptyModel = function (e) {
                    if (!$scope.model || !$scope.model.length) {
                        return;
                    }
                    e.preventDefault();
                    e.stopPropagation();
                    $scope.model = [];
                };
                $scope.getLabel = function (id) {
                    var variant = _($scope.variants).find(function (v) {
                        if (_(v).isObject()) {
                            return v.id === id;
                        }
                        return v === id;
                    });
                    if (_(variant).isUndefined()) {
                        return '';
                    }
                    if (_(variant).isObject()) {
                        return variant.label;
                    }
                    return variant;
                };
                $scope.modelLabel = function () {
                    var id;
                    if ($scope.multiple) {
                        if ($scope.options.selectedLabelType === 'empty' || !$scope.model || !$scope.model.length) {
                            return $scope.options.emptyLabel || '';
                        }
                        if ($scope.model.length > 1) {
                            return $scope.model.length + ' items selected';
                        }
                        id = $scope.model[0];
                    } else {
                        id = $scope.model;
                    }
                    return $scope.getLabel(id);
                };
                $scope.getModelTooltip = function () {
                    if ($scope.multiple) {
                        return $scope.options.tooltip;
                    }
                    if ($scope.options.defaultTooltip) {
                        return $scope.options.tooltip;
                    }
                    var id = $scope.model;
                    var variant = _($scope.variants).find(function (v) {
                        if (_(v).isObject()) {
                            return v.id === id;
                        }
                        return v === id;
                    });
                    if (_(variant).isUndefined()) {
                        return;
                    }
                    return $scope.getVariantTooltip(variant);
                };
                $scope.variantVisible = function (variant) {
                    if (!$scope.hideSelected) {
                        return true;
                    }
                    if (_(variant).isObject()) {
                        return variant.id !== $scope.model;
                    }
                    return variant !== $scope.model;
                };
                $scope.hideSelector = function () {
                    return $scope.variants && $scope.variants.length === 1 && !$scope.variantVisible($scope.variants[0]);
                };
                $scope.getVariantLabel = function (variant) {
                    if (_(variant).isObject()) {
                        return variant.label || variant.title;
                    }
                    return variant;
                };
                $scope.isSelected = function (variant) {
                    var value = _(variant).isObject() ? variant.id : variant;
                    return _($scope.model).includes(value);
                };
                $scope.getVariantTooltip = function (variant) {
                    if (!variant) {
                        return '';
                    }
                    return variant.tooltip;
                };
                $scope.variantsTruncationTips = {};
                $scope.getVariantTruncationTip = function (variant) {
                    return $scope.variantsTruncationTips[_(variant).isObject() ? variant.id : variant];
                };
                $scope.checkTruncation = function ($event, variant) {
                    var id = _(variant).isObject() ? variant.id : variant;
                    var oldValue = $scope.variantsTruncationTips[id];
                    if ($event.currentTarget.offsetWidth < $event.currentTarget.scrollWidth) {
                        $scope.variantsTruncationTips[id] = $event.currentTarget.innerHTML;
                    } else {
                        delete $scope.variantsTruncationTips[id];
                    }
                    if (oldValue != $scope.variantsTruncationTips[id]) {
                        $timeout(function () {
                            $($event.currentTarget).trigger($event.type);
                        });
                    }
                };
                $scope.modelTruncationTip = null;
                $scope.checkModelTruncation = function ($event) {
                    var children = $($event.currentTarget).children('.linked-text');
                    if (!children.length) {
                        return;
                    }
                    var el = children[0];
                    var oldValue = $scope.modelTruncationTip;
                    if (el.offsetWidth < el.scrollWidth) {
                        $scope.modelTruncationTip = el.innerHTML;
                    } else {
                        $scope.modelTruncationTip = null;
                    }
                    if (oldValue != $scope.modelTruncationTip) {
                        $timeout(function () {
                            $($event.currentTarget).trigger($event.type);
                        });
                    }
                };
                var idOfSetTimeOut;
                $scope.autoClose = function () {
                    idOfSetTimeOut = setTimeout(function () {
                        $scope.isOpen = false;
                    }, 2000);
                };
                $scope.cancelAutoClose = function () {
                    clearTimeout(idOfSetTimeOut);
                };
                var locationChanged = false;
                $scope.$on('$locationChangeSuccess', function (event) {
                    locationChanged = true;
                });
                var openValue;
                $scope.$watch('isOpen', function (val, oldState) {
                    if ($scope.options.keepOpenOnLocation) {
                        if (!val) {
                            if (locationChanged) {
                                $scope.isOpen = true;
                            }
                            locationChanged = false;
                        }
                    }
                    if (val && $scope.hideSelector()) {
                        $scope.isOpen = false;
                        return;
                    }
                    if ($scope.options.emitChangeOnClose) {
                        if (val) {
                            openValue = angular.copy($scope.model);
                        } else {
                            if (oldState === true) {
                                if ($scope.multiple) {
                                    var oldVal = openValue || [];
                                    var newVal = $scope.model || [];
                                    if (oldVal.length !== newVal.length || _(oldVal).intersection(newVal).length !== oldVal.length) {
                                        $scope.change({
                                            newValue: newVal,
                                            oldValue: oldVal
                                        });
                                    }
                                }
                            }
                        }
                    }
                });
            }
        };
    }]);
}());